import { DataFieldType } from "@iventis/domain-model/model/dataFieldType";
import { VenueLocation } from "@iventis/domain-model/model/venueLocation";
import { Node } from "@iventis/domain-model/model/node";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { Status } from "@iventis/domain-model/model/status";
import { Authorisation } from "@iventis/domain-model/model/authorisation";
import { ScheduleConfig } from "@iventis/domain-model/model/scheduleConfig";
import { ScheduleConfigVersionType } from "@iventis/domain-model/model/scheduleConfigVersionType";
import { DataFieldListItem } from "@iventis/domain-model/model/dataFieldListItem";

export interface ScheduleNode extends Node {
    childNodes: ScheduleNode[];
    visible: boolean;
    colour?: string;
    editName?: boolean;
}

export const mockScheduleConfig: ScheduleConfig = {
    name: "Birmingham 2022",
    enableRecurringEvents: false,
    dataFields: [
        {
            id: "sport",
            name: "Sport",
            type: DataFieldType.List,
            listValues: [{ id: "swimming", name: "Swimming" } as DataFieldListItem, { id: "hockey", name: "Hockey" } as DataFieldListItem],
        },
    ],
    scheduleVersionTypes: [
        { id: "schedule", name: "Schedule", allowedParentType: null, dataFields: ["sport"] },
        { id: "sport-schedule", name: "Discipline schedule", allowedParentType: "schedule", dataFields: ["sport"] },
    ],
    eventBlockTypes: [],
} as ScheduleConfig;

export const mockScheduleVersionTypes = mockScheduleConfig.scheduleVersionTypes.reduce((acc, versionType) => {
    if (!versionType.allowedParentType) {
        acc.schedule = versionType;
    } else {
        acc.subSchedule = versionType;
    }
    return acc;
}, {} as { schedule: ScheduleConfigVersionType; subSchedule: ScheduleConfigVersionType });

const scheduleChildren3: ScheduleNode[] = [
    {
        // Example of full calendar node
        name: "Archery 3.0",
        visible: true,
        id: "A30",
        parentId: "CS3",
        type: NodeType.ScheduleVersion,
        childNodes: [],
        favourite: false,
        sourceId: "A30",
        authorisation: Authorisation.Admin,
        expanded: false,
        status: Status.Active,
        createdByUserId: "string",
        createdByUserName: "string",
        createdAt: new Date("2021-09-02T14:03:22.481Z"),
        lastUpdatedByUserId: "string",
        lastUpdatedByUserName: "string",
        lastUpdatedAt: new Date("2021-09-02T14:03:22.481Z"),
        childCount: 0,
    },
    {
        name: "Archery 3.1",
        visible: true,
        id: "A31",
        parentId: "CS3",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
    {
        name: "Swimming 3.0",
        visible: true,
        id: "S3",
        parentId: "CS3",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
    {
        name: "Track and Field 3.0",
        visible: true,
        id: "TF3",
        parentId: "CS3",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
    {
        name: "Table Tennis 3.0",
        visible: true,
        id: "TT3",
        parentId: "CS3",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
];

export const scheduleChildren2: ScheduleNode[] = [
    {
        name: "Archery 2.0",
        visible: true,
        id: "A20",
        parentId: "CS2",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
    {
        name: "Archery 2.1",
        visible: true,
        id: "A21",
        parentId: "CS2",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
    {
        name: "Swimming 2.0",
        visible: true,
        id: "S2",
        parentId: "CS2",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
    {
        name: "Track and Field 2.0",
        visible: true,
        id: "TF2",
        parentId: "CS2",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
    {
        name: "Table Tennis 2.0",
        visible: true,
        id: "TT2",
        parentId: "CS2",
        type: NodeType.ScheduleVersion,
        childNodes: [],
    } as ScheduleNode,
];

export const scheduleMockData: ScheduleNode[] = [
    { name: "Competition Schedule 3.0", visible: true, id: "CS3", colour: "#00e4f0", childNodes: scheduleChildren3 } as ScheduleNode,
    { name: "Competition Schedule 2.0", visible: true, id: "CS2", colour: "#00e4f0", childNodes: [] } as ScheduleNode,
    { name: "Competition Schedule 2.0 (Mayor Edition)", visible: true, id: "CS2M", colour: "#f0a400", childNodes: [] } as ScheduleNode,
];

export const filterableDataFields = [
    {
        id: "1",
        name: "Discipline",
        type: DataFieldType.List,
        listValues: [
            { id: "Snowboard", name: "Snowboard" },
            { id: "Freestyle-Skiing", name: "Freestyle Skiing" },
            { id: "Curling", name: "Curling" },
            { id: "Alpine-Skiing", name: "Alpine Skiing" },
        ],
    },
];

export const venueLocations: VenueLocation[] = [
    { name: "gan", id: "gan", dataFieldValues: undefined, parentId: undefined } as VenueLocation,
    { name: "nu", id: "nu", dataFieldValues: undefined, parentId: undefined } as VenueLocation,
];

export const mockScheduleVersions: Node[] = [
    {
        id: "2",
        name: "Comp Schedule V 2",
        childNodes: [{ id: "2a", name: "Archery V 2" } as Node, { id: "2b", name: "Football V 2" } as Node],
    } as Node,
    {
        id: "1",
        name: "Comp Schedule V 1",
        childNodes: [{ id: "1a", name: "Archery V 1" } as Node, { id: "1b", name: "Football V 1" } as Node],
    } as Node,
];
